import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { useTheme } from '@mui/material/styles';

import { useQuery } from '@shared/helpers';
import { Button } from '@shared/components/Button';
import { useDevicePairingUIStore } from '@core/useStores';

import { messages } from './devicePairing.messages';
import { ThemeProps } from '@styles/theme';

// The headset will eventually draw a QR pointing here; until then the query parameter is what a
// copied link carries. It is also what the identity service puts in verification_uri.
const QUERY_CODE = 'code';

const useStyles = createUseStyles((theme: ThemeProps) => ({
    wrapper: {
        backgroundColor: theme.colors.white,
        padding: `${theme.spacing(8)} ${theme.spacing(6)}`,
        border: `1.5px solid ${theme.colors.grey_light}`,
        borderRadius: theme.radius,
        maxWidth: 480,
    },

    title: {
        color: theme.colors.text_heading,
        fontSize: 20,
        fontWeight: 600,
        fontFamily: theme.font.secondary,
        margin: 0,
    },

    subtitle: {
        color: theme.colors.grey_text,
        margin: `${theme.spacing(2)} 0 ${theme.spacing(6)}`,
    },
}));

/**
 * The landing page behind the pairing dialog, at the verification_uri the headset displays.
 * It opens the dialog straight away; the page itself only exists so that dismissing the dialog
 * does not leave the user staring at nothing.
 */
export const DevicePairing: React.FC = () => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const devicePairingUIStore = useDevicePairingUIStore();

    const query = useQuery();
    const codeFromQuery = query.get(QUERY_CODE) || '';

    useEffect(() => {
        devicePairingUIStore.openModal(codeFromQuery);
    }, []);

    return (
        <div className={styles.wrapper}>
            <h3 className={styles.title}>{messages['devicePairing.landing.title']}</h3>
            <p className={styles.subtitle}>{messages['devicePairing.landing.subtitle']}</p>

            <Button onClick={() => devicePairingUIStore.openModal(codeFromQuery)}>
                {messages['devicePairing.action.openDialog']}
            </Button>
        </div>
    );
}
